import * as React from "react";

import {
  Box,
  Checkbox,
  FormControlLabel,
  makeStyles,
  Theme,
} from "@material-ui/core";

import { Product } from "client/lib/apt-merchant/src/types/product";

import { PrivacyPolicy } from "./PrivacyPolicy";

const useStyles = makeStyles((theme: Theme) => ({
  checkbox: {
    paddingTop: 0,
  },
  checkboxWrapper: {
    alignItems: "flex-start",
    fontSize: `${10 / 16}rem`,
  },
  spacer: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  arrow: {
    color: theme.palette.common.black,
  },
  text: {
    fontSize: `${14 / 16}rem`,
    lineHeight: 1.5,
    textAlign: "center",
  },
  tooltip: {
    minWidth: 300,
    backgroundColor: theme.palette.common.black,
  },
}));

interface MerchantAgreement {
  isAgreementAccepted: boolean;
  onChange: (e: any, checked: boolean) => void;
  disableCheckbox: boolean;
  product: Product;
}

export const MerchantAgreementForm: React.FC<MerchantAgreement> = ({
  onChange,
  isAgreementAccepted,
  disableCheckbox,
  product,
}) => {
  const classes = useStyles();

  const MerchantAgreementFormContent = (
    <FormControlLabel
      className={classes.checkboxWrapper}
      control={
        <Checkbox
          data-testid="merchant-agreement-checkbox"
          checked={isAgreementAccepted}
          classes={{
            root: classes.checkbox,
          }}
          onChange={onChange}
          disabled={disableCheckbox}
        />
      }
      label={<PrivacyPolicy product={product} />}
    />
  );

  return !disableCheckbox ? (
    <Box className={classes.spacer}>{MerchantAgreementFormContent}</Box>
  ) : null;
};
